import React from 'react';
import {Subscribe} from 'unstated';
import {Dropdown, Button, ButtonGroup} from 'react-bootstrap';
import LanguageDataContainer from '../Stores/LanguageDataContainer';
import { myGlobals } from '../Utils';

class LanguageSelectionDropDown extends React.Component{
    languageDropdownOnChange = async (data, languagedata) => {
    	this.getLanguageJson(data, languagedata);
        await languagedata.setLanguage(data);
    }
    
    getLanguageJson = (langCode, languagedata) => {
	    let link = `${myGlobals.initialHost}${myGlobals.appender}i18nGP/i18nGP_${langCode}.json`;
	      
	    fetch(link, {
	      method: "GET",
	    }).then(resp => resp.json())
      .then((data) => {
        languagedata.setMessages(data);
        myGlobals.messages = data
      });
  	};
    populateOptions = (languagedata) => {
      let options = [];
      languagedata.state.dropDownValues.forEach((dropdown)=>{
        let optionClass = languagedata.getLanguage() === dropdown.value ? "clicked" : "";
        options.push( 
          <Dropdown.Item className={optionClass}  key={dropdown.name} eventKey={dropdown.value} >{dropdown.name}</Dropdown.Item>
        );
      });
      return options;
    }
    isTopBuild = () => {
      if(!this.props.isTopBuild)
        return "language-dropdown-standard";
    }
    render(){
      return (
          <Subscribe to={[LanguageDataContainer]}>
            {languagedata => (
              ( !myGlobals.isDirectDebitLoaded  && (
              <Dropdown onSelect={ (evt) => this.languageDropdownOnChange(evt, languagedata) } className="dropdown-langauge" as={ButtonGroup}>
                <Button id="dropdown-button-main" variant="success"><span id="lang-dropdown-text">{languagedata.getLanguageName()}</span></Button>

                <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />

                <Dropdown.Menu>
                  {this.populateOptions(languagedata)}
                </Dropdown.Menu>
              </Dropdown>
            ))
            )}
          </Subscribe>
      );
    }
}

export default LanguageSelectionDropDown;
